
import { PropType, defineComponent, watch } from "vue";
import { Modal } from "bootstrap";
export default defineComponent({
  name: "ModalDelRegister",
  props: {
    header: {
      type: String,
      default: "Excluir registro!"
    },
    name: {
      type: String,
      default: "Registro"
    },
    message: {
      type: String,
      default: "O registro selecionado será excluído."
    },
    question: {
      type: String,
      default: "Deseja excluir"
    },
    toggle: {
      type: Boolean,
      default: false
    },
    handleButtonClick: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props, { emit }) {
    // Variables
    let auxModal

    // Functions
    const openModal = (id: string) => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal = new Modal(auxElement);
      auxModal.show();
    }

    // Life Cycles
    watch(() => props.toggle, () => openModal("ModalDelRegister"))

    return { }
  }
})
